import ApiRequest from '../api/request';

type Params = { route: 'classy'; action: any; params?: any };

export default class Classy {
  static async Interact(params: Params, apiToken: string) {
    console.log('\t\tClassy.Interact()');
    try {
      if (params.action === 'report') {
        return Classy.Report(params, apiToken);
      }
    } catch (err: any) {
      return { error: err.message };
    }
  }

  static async Report(params: Params, apiToken: string) {
    console.log('\t\tClassy.Report()');
    try {
      const response = await ApiRequest.sendRequest({
        method: 'post',
        params: params.params,
        path: `classy/${params.action}`,
        token: apiToken,
      });
      return response.data;
    } catch (err: any) {
      return { error: err.message };
    }
  }
}
